// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.chat {
	margin-top: auto;
	margin-bottom: auto;
}
#usuarionome {
	color: #ffffff
}

#heaadermsg {
	background-color: #1d09b2;
}
#footermsg {
	background-color:#1d09b2;
}

#chat1 {
    height: 500px;
    border-radius: 15px !important;
    background-color: #585859;
    background-size: cover; /* Ajusta o tamanho da imagem para cobrir todo o contêiner */
    background-position: center; /* Centraliza a imagem no contêiner */
}
.card {
    height: 500px;
    border-radius: 15px !important;
    background: linear-gradient(to bottom, #8a898d, #7f7f83); /* Gradiente vertical de cinza para azul */
    background-size: cover;
    background-position: center;
}

#sms {
	color: #ffffff;
}
.card-footer {
	background-color:#1d09b2;
}

.card_chats{
	background-color:#1d09b2;
	height: 50px;
	border-radius: 5px;
}
.card_chats h2{
	color:#fbfbfb
	
}



.contacts_body {
	padding: 0.75rem 0 !important;
	overflow-y: auto;
	white-space: nowrap;
}

.msg_card_body {
	overflow-y: auto;
}

.container {
	align-content: center;
}

/* Adiciona espaçamento à área de mensagem */
.type_msg {
	background-color: rgb(255, 255, 255) !important;
	border: 1px solid; /* Adapte a cor e estilo da borda conforme necessário */
	color: rgb(29, 28, 28) !important;
	height: 49px; /* Altura em relação à altura da viewport (viewport height) */
	padding: 10px; /* Adiciona algum espaço interno para o conteúdo */
	margin-right: 8px;
	margin-bottom: 8px;
  }
  
  /* Ajusta o layout do botão "Enviar" */
  .btn-primary {
	margin-left: 8px; /* Adicione o espaçamento desejado à esquerda */
  }

  .btn-secondary{
	margin-right: 8px; /* Adicione o espaçamento desejado à esquerda */
  }
  
  
.type_msg:focus {
	box-shadow: none !important;
	outline: 0px !important;
}

.contacts {
	list-style: none;
	padding: 0;
}

.contacts li {
	width: 100% !important;
	padding: 5px 10px;
	margin-bottom: 15px !important;
}

.active {
	background-color: rgba(0, 0, 0, 0.3);
}

.online_icon {
	position: absolute;
	height: 15px;
	width: 15px;
	background-color: #4cd137;
	border-radius: 50%;
	bottom: 13px;
	right: 13px;
	border: 1.5px solid white;
}

.offline {
	background-color: #c23616 !important;
}

.user_info {
	margin-top: auto;
	margin-bottom: auto;
	margin-left: 15px;
}
.user_info span:hover {
	margin-top: auto;
	border-radius: 5px;
    background-color: #130687;
	padding-right: 300px;
	padding-bottom:20px;
	padding-top: 20px;
}

.user_info span {
	font-size: 20px;
	color: rgb(255, 255, 255);
}

.user_info p {
	font-size: 10px;
	color: rgba(254, 254, 254, 0.6);
}


.msg_cotainer {
	margin-top: auto;
	margin-bottom: auto;
	margin-left: 10px;
	border-radius: 25px;
	background-color: #f9f9f9;
	padding: 10px;
	color: #080000;
	position: relative;
}

.msg_cotainer_send {
	color: #ffffff;
	margin-top: auto;
	margin-bottom: auto;
	margin-right: 10px;
	border-radius: 25px;
	background-color: #4430f5;
	padding: 10px;
	position: relative;
}

.msg_time {
	position: absolute;
	left: 0;
	bottom: -15px;
	color: rgba(255, 255, 255, 0.5);
	font-size: 10px;
}

.msg_time_send {
	position: absolute;
	right: 0;
	bottom: -15px;
	color: rgba(255, 255, 255, 0.5);
	font-size: 10px;
}

.msg_head {
	position: relative;
}

#action_menu_btn {
	position: absolute;
	right: 10px;
	top: 10px;
	color: white;
	cursor: pointer;
	font-size: 20px;
}

.action_menu {
	z-index: 1;
	position: absolute;
	padding: 15px 0;
	background-color: rgba(0, 0, 0, 0.5);
	color: white;
	border-radius: 15px;
	top: 30px;
	right: 15px;
	display: none;
}

.action_menu ul {
	list-style: none;
	padding: 0;
	margin: 0;
}

.action_menu ul li {
	width: 100%;
	padding: 10px 15px;
	margin-bottom: 5px;
}

.action_menu ul li i {
	padding-right: 10px;
}

.action_menu ul li:hover {
	cursor: pointer;
	background-color: rgba(0, 0, 0, 0.2);
}


/* width */

::-webkit-scrollbar {
	width: 10px;
}


/* Track */

::-webkit-scrollbar-track {
	background: #f1f1f1;
}


/* Handle */

::-webkit-scrollbar-thumb {
	background: #888888;
}


/* Handle on hover */

::-webkit-scrollbar-thumb:hover {
	background: #555555;
}

@media(max-width: 576px) {
	.contacts_card {
		margin-bottom: 15px !important;
	}
}`, "",{"version":3,"sources":["webpack://./src/chat/Chat.css"],"names":[],"mappings":";AACA;CACC,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC;AACD;;AAEA;CACC,yBAAyB;AAC1B;AACA;CACC,wBAAwB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,sBAAsB,EAAE,4DAA4D;IACpF,2BAA2B,EAAE,qCAAqC;AACtE;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,wDAAwD,EAAE,0CAA0C;IACpG,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;CACC,cAAc;AACf;AACA;CACC,wBAAwB;AACzB;;AAEA;CACC,wBAAwB;CACxB,YAAY;CACZ,kBAAkB;AACnB;AACA;CACC;;AAED;;;;AAIA;CACC,6BAA6B;CAC7B,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;AACtB;;AAEA,4CAA4C;AAC5C;CACC,+CAA+C;CAC/C,iBAAiB,EAAE,uDAAuD;CAC1E,iCAAiC;CACjC,YAAY,EAAE,6DAA6D;CAC3E,aAAa,EAAE,kDAAkD;CACjE,iBAAiB;CACjB,kBAAkB;EACjB;;EAEA,sCAAsC;EACtC;CACD,gBAAgB,EAAE,+CAA+C;EAChE;;EAEA;CACD,iBAAiB,EAAE,+CAA+C;EACjE;;;AAGF;CACC,2BAA2B;CAC3B,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,sBAAsB;CACtB,iBAAiB;CACjB,8BAA8B;AAC/B;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,yBAAyB;CACzB,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,iBAAiB;AAClB;AACA;CACC,gBAAgB;CAChB,kBAAkB;IACf,yBAAyB;CAC5B,oBAAoB;CACpB,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,+BAA+B;AAChC;;;AAGA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,iBAAiB;CACjB,mBAAmB;CACnB,yBAAyB;CACzB,aAAa;CACb,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;CAClB,mBAAmB;CACnB,yBAAyB;CACzB,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,aAAa;CACb,+BAA+B;CAC/B,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,aAAa;CACb,+BAA+B;CAC/B,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,YAAY;CACZ,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,UAAU;CACV,kBAAkB;CAClB,eAAe;CACf,oCAAoC;CACpC,YAAY;CACZ,mBAAmB;CACnB,SAAS;CACT,WAAW;CACX,aAAa;AACd;;AAEA;CACC,gBAAgB;CAChB,UAAU;CACV,SAAS;AACV;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,oCAAoC;AACrC;;;AAGA,UAAU;;AAEV;CACC,WAAW;AACZ;;;AAGA,UAAU;;AAEV;CACC,mBAAmB;AACpB;;;AAGA,WAAW;;AAEX;CACC,mBAAmB;AACpB;;;AAGA,oBAAoB;;AAEpB;CACC,mBAAmB;AACpB;;AAEA;CACC;EACC,8BAA8B;CAC/B;AACD","sourcesContent":["\n.chat {\n\tmargin-top: auto;\n\tmargin-bottom: auto;\n}\n#usuarionome {\n\tcolor: #ffffff\n}\n\n#heaadermsg {\n\tbackground-color: #1d09b2;\n}\n#footermsg {\n\tbackground-color:#1d09b2;\n}\n\n#chat1 {\n    height: 500px;\n    border-radius: 15px !important;\n    background-color: #585859;\n    background-size: cover; /* Ajusta o tamanho da imagem para cobrir todo o contêiner */\n    background-position: center; /* Centraliza a imagem no contêiner */\n}\n.card {\n    height: 500px;\n    border-radius: 15px !important;\n    background: linear-gradient(to bottom, #8a898d, #7f7f83); /* Gradiente vertical de cinza para azul */\n    background-size: cover;\n    background-position: center;\n}\n\n#sms {\n\tcolor: #ffffff;\n}\n.card-footer {\n\tbackground-color:#1d09b2;\n}\n\n.card_chats{\n\tbackground-color:#1d09b2;\n\theight: 50px;\n\tborder-radius: 5px;\n}\n.card_chats h2{\n\tcolor:#fbfbfb\n\t\n}\n\n\n\n.contacts_body {\n\tpadding: 0.75rem 0 !important;\n\toverflow-y: auto;\n\twhite-space: nowrap;\n}\n\n.msg_card_body {\n\toverflow-y: auto;\n}\n\n.container {\n\talign-content: center;\n}\n\n/* Adiciona espaçamento à área de mensagem */\n.type_msg {\n\tbackground-color: rgb(255, 255, 255) !important;\n\tborder: 1px solid; /* Adapte a cor e estilo da borda conforme necessário */\n\tcolor: rgb(29, 28, 28) !important;\n\theight: 49px; /* Altura em relação à altura da viewport (viewport height) */\n\tpadding: 10px; /* Adiciona algum espaço interno para o conteúdo */\n\tmargin-right: 8px;\n\tmargin-bottom: 8px;\n  }\n  \n  /* Ajusta o layout do botão \"Enviar\" */\n  .btn-primary {\n\tmargin-left: 8px; /* Adicione o espaçamento desejado à esquerda */\n  }\n\n  .btn-secondary{\n\tmargin-right: 8px; /* Adicione o espaçamento desejado à esquerda */\n  }\n  \n  \n.type_msg:focus {\n\tbox-shadow: none !important;\n\toutline: 0px !important;\n}\n\n.contacts {\n\tlist-style: none;\n\tpadding: 0;\n}\n\n.contacts li {\n\twidth: 100% !important;\n\tpadding: 5px 10px;\n\tmargin-bottom: 15px !important;\n}\n\n.active {\n\tbackground-color: rgba(0, 0, 0, 0.3);\n}\n\n.online_icon {\n\tposition: absolute;\n\theight: 15px;\n\twidth: 15px;\n\tbackground-color: #4cd137;\n\tborder-radius: 50%;\n\tbottom: 13px;\n\tright: 13px;\n\tborder: 1.5px solid white;\n}\n\n.offline {\n\tbackground-color: #c23616 !important;\n}\n\n.user_info {\n\tmargin-top: auto;\n\tmargin-bottom: auto;\n\tmargin-left: 15px;\n}\n.user_info span:hover {\n\tmargin-top: auto;\n\tborder-radius: 5px;\n    background-color: #130687;\n\tpadding-right: 300px;\n\tpadding-bottom:20px;\n\tpadding-top: 20px;\n}\n\n.user_info span {\n\tfont-size: 20px;\n\tcolor: rgb(255, 255, 255);\n}\n\n.user_info p {\n\tfont-size: 10px;\n\tcolor: rgba(254, 254, 254, 0.6);\n}\n\n\n.msg_cotainer {\n\tmargin-top: auto;\n\tmargin-bottom: auto;\n\tmargin-left: 10px;\n\tborder-radius: 25px;\n\tbackground-color: #f9f9f9;\n\tpadding: 10px;\n\tcolor: #080000;\n\tposition: relative;\n}\n\n.msg_cotainer_send {\n\tcolor: #ffffff;\n\tmargin-top: auto;\n\tmargin-bottom: auto;\n\tmargin-right: 10px;\n\tborder-radius: 25px;\n\tbackground-color: #4430f5;\n\tpadding: 10px;\n\tposition: relative;\n}\n\n.msg_time {\n\tposition: absolute;\n\tleft: 0;\n\tbottom: -15px;\n\tcolor: rgba(255, 255, 255, 0.5);\n\tfont-size: 10px;\n}\n\n.msg_time_send {\n\tposition: absolute;\n\tright: 0;\n\tbottom: -15px;\n\tcolor: rgba(255, 255, 255, 0.5);\n\tfont-size: 10px;\n}\n\n.msg_head {\n\tposition: relative;\n}\n\n#action_menu_btn {\n\tposition: absolute;\n\tright: 10px;\n\ttop: 10px;\n\tcolor: white;\n\tcursor: pointer;\n\tfont-size: 20px;\n}\n\n.action_menu {\n\tz-index: 1;\n\tposition: absolute;\n\tpadding: 15px 0;\n\tbackground-color: rgba(0, 0, 0, 0.5);\n\tcolor: white;\n\tborder-radius: 15px;\n\ttop: 30px;\n\tright: 15px;\n\tdisplay: none;\n}\n\n.action_menu ul {\n\tlist-style: none;\n\tpadding: 0;\n\tmargin: 0;\n}\n\n.action_menu ul li {\n\twidth: 100%;\n\tpadding: 10px 15px;\n\tmargin-bottom: 5px;\n}\n\n.action_menu ul li i {\n\tpadding-right: 10px;\n}\n\n.action_menu ul li:hover {\n\tcursor: pointer;\n\tbackground-color: rgba(0, 0, 0, 0.2);\n}\n\n\n/* width */\n\n::-webkit-scrollbar {\n\twidth: 10px;\n}\n\n\n/* Track */\n\n::-webkit-scrollbar-track {\n\tbackground: #f1f1f1;\n}\n\n\n/* Handle */\n\n::-webkit-scrollbar-thumb {\n\tbackground: #888888;\n}\n\n\n/* Handle on hover */\n\n::-webkit-scrollbar-thumb:hover {\n\tbackground: #555555;\n}\n\n@media(max-width: 576px) {\n\t.contacts_card {\n\t\tmargin-bottom: 15px !important;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
